import { useGetShipNoteQuery } from 'app/api/facade';
import styles from './ShipNote.module.scss';

interface ShipNoteProps {
  mmsi?: number;
}

export const ShipNote = ({ mmsi }: ShipNoteProps) => {
  const { data } = useGetShipNoteQuery(mmsi, { skip: typeof mmsi !== 'number' });
  const note = data?.notes?.[0];

  if (!note) return null;
  return <div className={styles.ship_note}>{note.message}</div>;
};
